import React, { createContext, useState, useEffect } from "react";
import SamplesService from '../services/samples';
import { sessionStorage } from "../state/utils/storage";
import useBrowserMode from "./useBrowserMode";

export const SampleContext = createContext();

export const SampleProvider = ({ children }) => {
  
  const [hasSamplesAvailable, setHasSamplesAvailable] = useState(true);
  const { isBrowser } = useBrowserMode()
  
  
  const localeConfig = {
    "es-CO": 1,
    "es-EC": 5,
    "es-PE": 6,
    "es-BO": 7,
    "es-CL": 8,
    "es-AR": 9,
    "es-PY": 10,
    "es-PR": 12,
    "es-DO": 13,
  };
  
  const locale = process.env.LOCALE || "es-CO"
  const countryNumber = localeConfig[locale]
  
  useEffect(() => {
    sessionStorage.setItem("hasSamplesAvailable", true)
    if (locale === "es-CO") {
      const checkSampleLimit = value => {
        SamplesService.checkSampleLimit(value).then(res => {
          if (res?.data?.status === 400 && res?.data?.errorCode === "DEM107" && res?.data?.data) {
            sessionStorage.setItem("hasSamplesAvailable", false)
            setHasSamplesAvailable(false)
          } else if (res?.data?.status === 200 && !res?.data?.data) {
            sessionStorage.setItem("hasSamplesAvailable", true)
            setHasSamplesAvailable(true)
          }
        }).catch(err => err);
      }

      checkSampleLimit(countryNumber);
    }
  }, []);

  return (
    <SampleContext.Provider value={{ hasSamplesAvailable }}>
      {children}
    </SampleContext.Provider>
  );
};